import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const VARIANT_STYLES = {
  default: 'text-neutral-500',
  warning: 'text-warning-600',
  danger: 'text-danger-600',
  disabled: 'text-neutral-400'
};

const StepDescription = ({ description, isDisabled }) => {
  if (!description?.text) return null;

  const variant = isDisabled ? 'disabled' : (description.variant ?? 'default');

  return (
    <div className={cn('flex items-center gap-1 text-xs leading-5', VARIANT_STYLES[variant])}>
      {description.icon && <Icon icon={description.icon} size={12} />}
      <span className="truncate">{description.text}</span>
      {description.suffix && (
        <span className={cn('flex-shrink-0', isDisabled ? 'text-neutral-400' : 'text-neutral-700')}>
          • {description.suffix}
        </span>
      )}
    </div>
  );
};

export default StepDescription;
